import { createAction, props } from '@ngrx/store';
import { Payroll, EmployeePayableHour } from '../models/payroll.model';

// Load Payable Hours
export const loadPayableHours = createAction('[Payment->PayableHours] Load Payable Hours', props<{ organizationId: string, clientId: string, payrollId: number, weekNumber: number, isApproved?: boolean }>());
export const loadPayableHoursSuccess = createAction('[Payment->PayableHours] Load Payable Hours Success', props<{ payableHours: EmployeePayableHour[] }>());
// export const clearLoadedPayableHours = createAction('[Payment->PayableHours] Clear Loaded Payable Hours');
